namespace RedBullMOBILE360.CVM {
    export interface CriteriaConditionForm {
        Name: Serenity.StringEditor;
        Condition: Serenity.StringEditor;
    }

    export class CriteriaConditionForm extends Serenity.PrefixedContext {
        static formKey = 'CVM.CriteriaCondition';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CriteriaConditionForm.init)  {
                CriteriaConditionForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CriteriaConditionForm, [
                    'Name', w0,
                    'Condition', w0
                ]);
            }
        }
    }
}
